import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { customerPortalModuleManifest } from '../customer-portal.module.js';
import { customerPortalSettingRegistrations } from '../settings/customer-portal-setting-definitions.js';
export const customerPortalWebModuleContribution = {
    moduleId: 'customer-portal',
    manifest: customerPortalModuleManifest,
    settingRegistrations: customerPortalSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'customer-portal.web.projects.access-links',
            moduleId: 'customer-portal',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'customer-portal.project-links.read',
            settingCondition: null,
            priority: 90,
            errorBehavior: 'inline',
            emptyBehavior: 'collapse',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Customer portal',
                fallbackDescription: 'Manage this customer’s portal access and Project links.',
                defaultSize: 'wide',
                supportedSizes: ['standard', 'wide', 'large'],
            }),
            load: () => import('./customer-portal-project-links.panel.js'),
        }, {
            id: 'customer-portal.web.projects.intake',
            moduleId: 'customer-portal',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'customer-portal.project-intakes.read',
            settingCondition: {
                key: 'customer-portal.intake.configuration', property: 'enabled', equals: true,
            },
            priority: 89,
            errorBehavior: 'inline',
            emptyBehavior: 'collapse',
            load: () => import('./customer-portal-project-intakes.panel.js'),
        }],
    routes: [],
};
export default customerPortalWebModuleContribution;
//# sourceMappingURL=customer-portal-web.module-contribution.js.map